export default "/assets/images/google-play-store.ecc77b2558874776.svg";